import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { Card } from '@hivebrite/design-system/Card';
import { Divider } from '@hivebrite/design-system/Divider';
import { Loader } from '@hivebrite/design-system/Loader';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useBooking } from 'hb-react/shared/apps/Events/pages/Booking/hooks/useBooking';
import { PaymentProvider } from 'hb-react/shared/components/Payment/context/PaymentContext';
import { Gateway } from 'hb-react/shared/components/Payment/Gateway';
import { useShoppingCard } from 'hb-react/shared/components/ShoppingCard/hooks/v2';
import { goToPaymentPage } from 'hb-react/shared/utils/paymentPage';

export const RedirectToStandalonePaymentPage = () => {
  const { cart } = useBooking();
  const topicContext = useTopicContext();

  // Using useEffect to handle the redirect after render
  useEffect(() => {
    if (!cart) {
      throw new Error('cart required');
    }

    goToPaymentPage({ cartId: cart.id, topicContext });
  }, [cart, topicContext]);

  // Return null or a loading state while the redirect happens
  return <Loader size={32} />;
};

export const PaymentPage = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useShoppingCard();

  if (isLoading) {
    return <Loader size={32} />;
  }

  const onSuccess = () => {
    navigate('../success', { replace: true });
  };

  return (
    <Box display="block">
      <Card width="100%">
        <Box font="h3-semibold">{__('Payment details')}</Box>
        <Divider mt={3} width="100%" />
        <PaymentProvider onSuccess={onSuccess} data={data}>
          <Gateway />
        </PaymentProvider>
      </Card>
      <NavBar />
    </Box>
  );
};

const NavBar = () => {
  const navigate = useNavigate();

  return (
    <Box mt={6}>
      <Button onClick={() => navigate(-1)} variant="secondary">
        {s__('Memberships|Go back to registration')}
      </Button>
    </Box>
  );
};
